export default __webpack_public_path__ + "static/media/Supplier.c3359229.xlsx";